import { DialogTitle } from "@mui/material";
import { OpenAddHolding } from "../AddHolding";
import { TransactionType } from "../../shared/Consts";
import Holding from "../../models/Holding";
import { Transaction } from "../../models/Transaction";
import Utils from "../../libs/Utils";
import MenuButton from "../../libs/button/MenuButton";
import { TMenuOptions } from "../../libs/menu/GMenu";
import { useDialog } from "../../libs/dialog/DialogProvider";
import Redeem from "../Redeem";
import Reinvest from "../Reinvest";
import { GICTransaction } from "../../models/GICTransaction";

export default function HistoryTitle(props:{cols:string[],holding:Holding,transactions:Transaction[]}){
    const {transactions,holding} = props;
    const editHolding = OpenAddHolding()
    const {openDialog} = useDialog()
    
    const onAdd = () => editHolding(null, holding)
    const onDiv = () => editHolding(null, holding, TransactionType.dividend)
    const onReinvest = () => {
        if (holding.isGIC_or_bond) {
            const buy = transactions.find(trans => trans.isBuy)
            if (buy) openDialog({id:"redeem", children:<Redeem trans={buy as GICTransaction} reinvest={true}/>})
        }
        else holding.transactions.length>0 && openDialog({id:"reinvest", children:<Reinvest holding={holding}/>})
    }
    const onExport = () => {
        const text = transactions.map(trans => props.cols.map(col => trans.rawValue(col)).join(",")).join("\n")
        const blob = new Blob([text], {type:"text/csv;charset=utf-8"})
        Utils.exportFile(blob, `${holding.id}.csv`)
    }
    const options : TMenuOptions[] = [
        {value:"add", label:"Add", onClick:onAdd},
        {value:"div", label:"Dividend", onClick:onDiv},
        {value:"rev", label:"Reinvest", onClick:onReinvest},
        {value:"export", label:"Export", onClick:onExport}
    ]
    return <DialogTitle className="flex gap-8">
        <div className="ticker">{holding?.value("name")}</div>
        <MenuButton menuProps={ {options} }/>
    </DialogTitle>
}